import { useMemo } from 'react';
import { useSiteVisits } from './useSiteVisits';
import { useDateRange } from './useDateRange';
import { filterByRange } from '../lib/range';
import { isSpider } from '../lib/parse';
import type { Site } from '../lib/types';

export function useReportVisits(site: Site | null) {
  const visits = useSiteVisits(site);
  const range = useDateRange();

  const sliced = useMemo(() => {
    const humans = visits.filter((v) => !isSpider(v.userAgent));
    const spiders = visits.filter((v) => isSpider(v.userAgent));
    return {
      all: visits,
      humans,
      spiders,
      ranged: filterByRange(humans, range.bounds),
      spiderRanged: filterByRange(spiders, range.bounds),
    };
  }, [visits, range.bounds]);

  return { ...sliced, range };
}
